import React from 'react';
import {
  TreeView as MuiTreeView,
  TreeItem,
} from '@mui/x-tree-view';
import { StyledTreeView } from './TreeView.style';

export interface TreeItemData {
  id: string;
  label: string;
  children?: TreeItemData[];
  disabled?: boolean;
  icon?: React.ReactNode;
}

export interface TreeViewProps {
  /**
   * Tree data structure
   */
  data: TreeItemData[];
  /**
   * Default expanded node IDs
   */
  defaultExpanded?: string[];
  /**
   * Default selected node ID
   */
  defaultSelected?: string;
  /**
   * Whether multiple selection is enabled
   */
  multiSelect?: boolean;
  /**
   * Callback fired when tree items are selected
   */
  onNodeSelect?: (event: React.SyntheticEvent, nodeIds: string | string[]) => void;
  /**
   * Callback fired when tree items are expanded/collapsed
   */
  onNodeToggle?: (event: React.SyntheticEvent, nodeIds: string[]) => void;
}

const renderTreeItems = (items: TreeItemData[]): React.ReactNode => {
  return items.map((item) => (
    <TreeItem
      key={item.id}
      nodeId={item.id}
      label={item.label}
      disabled={item.disabled}
    >
      {item.children && item.children.length > 0 && renderTreeItems(item.children)}
    </TreeItem>
  ));
};

export const TreeView: React.FC<TreeViewProps> = ({
  data,
  defaultExpanded,
  defaultSelected,
  multiSelect = false,
  onNodeSelect,
  onNodeToggle,
}) => {
  return (
    <StyledTreeView
      defaultExpanded={defaultExpanded}
      defaultSelected={defaultSelected}
      multiSelect={multiSelect}
      onNodeSelect={onNodeSelect}
      onNodeToggle={onNodeToggle}
    >
      {renderTreeItems(data)}
    </StyledTreeView>
  );
}; 